module.exports = __webpack_public_path__ + "img/10.81f86faf.jpg";